var e=class{constructor(){this.promise=new Promise((i,o)=>{this.reject=o,this.resolve=i;});}};

export { e as a };
